import DongleIcon from './DongleIcon';

export default DongleIcon;
